<template>
  <div class="select-wrapper">
    <select
      class="form-control" 
      :id="selectId" 
      v-model="currentSelection"
      :aria-label="labelText">
        <option v-for="quarter in quarters" 
        :key="quarter.value"
        :value="quarter.value">
          {{quarter.name}}
        </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'quaterSelect',
  props: ['aorb', 'quarters', 'current', 'changeHandler'],
  data() {
    return {
      currentSelection: '',
      labelText: '',
      selectId: '',
    };
  },
  created() {
    this.currentSelection = this.current.value;
    this.labelText = `Quarter ${this.aorb}`;
    this.selectId = `select${this.aorb}`;
  },
  watch: {
    currentSelection() {
      this.changeHandler(this.aorb, this.currentSelection);
    },
  },
};
</script>

<style lang="less">
  .select-wrapper {
    flex: 1 1;
    padding-right: 3px;
    padding-left: 3px;
    align-self: flex-end;
  }
  .select-label {
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// QuarterSelect.vue?c023a65a